/* Petifo USP rail: mobile loop, offscreen pause, automatic editor reconnect. */
if (!customElements.get('pf-usp-rail')) {
  customElements.define('pf-usp-rail', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      const row = this.querySelector('.pf-usp__row');
      if (!row || row.children.length < 2) return;
      this._connected = true;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
        this._observer.observe(this);
      }
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this._connected = false;
      this._observer?.disconnect();
      this._observer = null;
    }
  });
}
